module.exports = __webpack_public_path__ + "img/vip.df606221.png";